export default __webpack_public_path__ + "static/media/web_dev.4d118f86.svg";